const local = {
  en: {
    name: 'Dmitrii Rakov',
    profession: 'Frontend Developer',
    hometown: 'Istanbul, Turkey',
    layoutTitle: 'Layout',
    layoutList: 'HTML Pug CSS SCSS/SASS LESS Stylus BEM SMACSS',
    jsTitle: 'JavaScript',
    jsList: 'JavaScript/Babbel React/Redux Typescript',
    designTitle: 'Design',
    designList: 'Figma AdobeXD Photoshop',
    environmentTitle: 'Environment',
    environmentList: 'Git/Github/Gitlab Docker Webpack/Gulp Jira/Basecamp PhpStorm/Sublime',
    supportSkillsTitle: 'Support skills',
    supportSkillsList: 'Php Node.js Next.js Jest',
    obsoleteSkillsTitle: 'Obsolete skills',
    obsoleteSkillsList: 'jQuery CoffeeScript Underscore.js Joomla Wordpress',
    languagesTitle: 'Languages',
    languagesList: {
      english: 'English - B2 (Upper-Intermediate)',
      russian: 'Russian - Native speaker',
      spanish: 'Spanish - A1 (Elementary)',
      turkey: 'Turkey - A1 (Elementary)'
    },
    contactsTitle: 'Contacts'
  },
  ru: {
    name: 'Дмитрий Раков',
    profession: 'Frontend-разработчик',
    hometown: 'Стамбул, Турция',
    layoutTitle: 'Верстка',
    layoutList: 'HTML Pug CSS SCSS/SASS LESS Stylus BEM SMACSS',
    jsTitle: 'JavaScript',
    jsList: 'JavaScript/Babbel React/Redux Typescript',
    designTitle: 'Дизайн',
    designList: 'Figma AdobeXD Photoshop',
    environmentTitle: 'Окружение',
    environmentList: 'Git/Github/Gitlab Docker Webpack/Gulp Jira/Basecamp PhpStorm/Sublime',
    supportSkillsTitle: 'Поддержка кода',
    supportSkillsList: 'Php Node.js Next.js Jest',
    obsoleteSkillsTitle: 'Устаревшие навыки',
    obsoleteSkillsList: 'jQuery CoffeeScript Underscore.js Joomla Wordpress',
    languagesTitle: 'Языки',
    languagesList: {
      english: 'Английский - B2 (Upper-Intermediate)',
      russian: 'Русский - Native speaker',
      spanish: 'Испанский - A1 (Elementary)',
      turkey: 'Турецкий - A1 (Elementary)'
    },
    contactsTitle: 'Контакты'
  }
};

export default local;
